import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './assets/styles/fonts.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

declare global {
  interface Window {
    redirectPath: string
  }
}

window.redirectPath = window.location.pathname

// React 18 API
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register()
